import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://essential-backend-beta.vercel.app/",
  // baseURL: "http://localhost:4000/",


});
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Get the token from local storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Set the token in the Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export const loginUser  = async (username, password) => {
  try {
    const response = await axiosInstance.post("/login", {
      username,
      password,
    });
    localStorage.setItem("token", response.data.token);
    return response.data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

// Function to create a package
export const createPackage = async (data) => {
  try {
    const response = await axiosInstance.post("/createPackage", data);
    return response.data;
  } catch (error) {
    console.error("Error sending request:", error);
    throw error;
  }
};

// Function to get all packages
export const getPackage = async () => {
  try {
    const response = await axiosInstance.get('/getPackages');
    return response.data;
  } catch (error) {
    console.error("Error fetching packages:", error);
    throw error;
  }
};
export const getAllNames = async () => {
  try {
    const response = await axiosInstance.get('/getAllNames');
    return response.data;
  } catch (error) {
    console.error("Error fetching packages:", error);
    throw error;
  }
};

// Function to get a package by ID
export const getPackageById = async (id) => {
  try {
    const response = await axiosInstance.get(`/getPackage/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching package by ID:", error);
    throw error;
  }
};

// Function to delete a package by ID
export const deletePackage = async (id) => {
  try {
    const response = await axiosInstance.delete(`/deletePackage/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting package:", error);
    throw error;
  }
};